// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"HorizontalBarsTooltip_tooltip__2vD10"};